import { render, staticRenderFns } from "./mProgramDetail.vue?vue&type=template&id=4149670d&scoped=true&"
import script from "./mProgramDetail.vue?vue&type=script&lang=js&"
export * from "./mProgramDetail.vue?vue&type=script&lang=js&"
import style0 from "./mProgramDetail.vue?vue&type=style&index=0&id=4149670d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4149670d",
  null
  
)

export default component.exports